<template>
    <div class="three-d-model" ref="ThreeDModel">
        <canvas id="c"></canvas>
        <button id="screenshot" type="button" v-if="screenshot"><v-icon>mdi-camera</v-icon></button>
        <button id="up" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-up"> mdi-arrow-up-circle-outline</v-icon>
        </button>
        <button id="right" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-right">mdi-arrow-right-circle-outline</v-icon>
        </button>
        <button id="down" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-down">mdi-arrow-down-circle-outline</v-icon>
        </button>
        <button id="left" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-left">mdi-arrow-left-circle-outline</v-icon>
        </button>
        <button id="log-rotate-counterclockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-log-rotate-counterclockwise">mdi-restore</v-icon>
        </button>
        <button id="log-rotate-clockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-log-rotate-clockwise">mdi-reload</v-icon>
        </button>

        <button id="horizontal-rotate-counterclockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-horizontal-rotate-counterclockwise">mdi-horizontal-rotate-counterclockwise</v-icon>
        </button>
        <button id="horizontal-rotate-clockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-horizontal-rotate-clockwise">mdi-horizontal-rotate-clockwise</v-icon>
        </button>
        <button id="axis-z-rotate-counterclockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-axis-z-rotate-counterclockwise">mdi-axis-z-rotate-counterclockwise</v-icon>
        </button>
        <button id="axis-z-rotate-clockwise" type="button"
            @mousedown="logCorrection" @mouseup="logCorrection"
            @touchstart="logCorrection" @touchend="logCorrection"
        >
            <v-icon id="i-axis-z-rotate-clockwise">mdi-axis-z-rotate-clockwise</v-icon>
        </button>


        <!--
        <div id="loading" v-if="loading">{{ $t("loading") }}</div>
        -->
        <!--
        <div id="info">
            {{ $t("time") }}: {{ model.head === undefined ? "" : model.head.TimeStamp }}<br>
            {{ $t("dTop") }}: {{ model.head === undefined ? 0 : model.head.TopD }} {{ $t("mm") }}<br>
            {{ $t("dButt") }}: {{ model.head === undefined ? 0 : (model.head.BackEndD > model.head.FrontEndD ? model.head.BackEndD : model.head.FrontEndD) }} {{ $t("mm") }}<br>
            {{ $t("length") }}: {{ model.head === undefined ? 0 : model.head.L }} {{ $t("cm") }}<br>
            {{ $t("curvature") }}: {{ model.head === undefined ? 0 : model.head.Curvature * .1 }}%<br>
            {{ $t("taper") }}: {{ model.head === undefined ? 0 : model.head.Sbeg }} {{ $t("cm") }}/{{ $t("m") }}<br>
        </div>
        -->

        <table class="info-table">
            <tbody>
                <tr>
                    <td><b>{{ $t("time") }}:</b></td>
                    <td>{{ model.head === undefined ? "" : `${new Date(model.head.TimeStamp).toLocaleDateString()} ${new Date(model.head.TimeStamp).toLocaleTimeString()}` }}</td>
                </tr>
                <tr>
                    <td><b>{{ $t("dTop") }}:</b></td>
                    <td>{{ model.head === undefined ? 0 : model.head.TopD }} {{ $t("mm") }}</td>
                </tr>
                <tr>
                    <td><b>{{ $t("dButt") }}:</b></td>
                    <td>{{ model.head === undefined ? 0 : (model.head.BackEndD > model.head.FrontEndD ? model.head.BackEndD : model.head.FrontEndD) }} {{ $t("mm") }}</td>
                </tr>
                <tr>
                    <td><b>{{ $t("length") }}:</b></td>
                    <td>{{ model.head === undefined ? 0 : model.head.L }} {{ $t("cm") }}</td>
                </tr>
                <tr>
                    <td><b>{{ $t("curvature") }}:</b></td>
                    <td>{{ model.head === undefined ? 0 : (model.head.Curvature * .1).toFixed(2) }}%</td>
                </tr>
                <tr>
                    <td><b>{{ $t("taper") }}:</b></td>
                    <td>{{ model.head === undefined ? 0 : model.head.Sbeg }} {{ $t("cm") }}/{{ $t("m") }}</td>
                </tr>
            </tbody>
        </table>

        <v-alert
            :value="alert !== ''"
            :type="alertType"
            transition="scale-transition"
            class="bottom-alert"
        >
            {{ alert }}
        </v-alert>
    </div>
</template>

<script>
    //import * as THREE from "three";
    import {
        BoxGeometry,
        BufferGeometry,
        DoubleSide,
        EdgesGeometry,
        Float32BufferAttribute,
        HemisphereLight,
        LineBasicMaterial,
        LineSegments,
        Mesh,
        MeshLambertMaterial,
        MeshStandardMaterial,
        PerspectiveCamera,
        Scene,
        WebGLRenderer,
    } from "three"; //"three/src/Three";
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import {Text}            from "troika-three-text";
//    import OrbitControls from "three-orbit-controls";

    export default {
        name: "ThreeDLogView",

        props: ["model", "pattern", "zScale", "screenshot"],

        data() {
            return {
                //screenshot: false
                alert:     "",
                alertType: "info",

                timerId:  null,
                scene:    null,
                renderer: null,
                camera:   null,
                logModel: null,
                models:   []
            }
        },

        watch: {
            alert: function (val) {
                if (val) {
                    setTimeout(() => this.alert = "", 1500);
                }
            },

            model: {
                handler: function (val) {
                    this.drawModel(val, this.zScale);
                },
                deep: true
            },

            pattern: {
                handler: function () {
                    //this.$debug.log('draw', this.models)
                    this.cleanupBoards();
                    this.drawPattern();

                    //this.$debug.log('draw', this.models)
                },
                deep: true
            },

            zScale: function (val) { this.drawModel(this.model, val); }
        },

        methods: {
            /**
             * Добавление границ объекту
             *
             * @param {object} object Объект к которому добавляются границы
             */
            addEdges (object) {
                const edgeGeo = new EdgesGeometry (object.geometry);
                const edgeMat = new LineBasicMaterial({ color: 0x6e2c10, linewidth: 10 });
                const edges   = new LineSegments (edgeGeo, edgeMat);

                object.add(edges);
            },

            /**
             * Расчёт шрифта для надписей с размерами сечений
             *
             * @param {number} t Высота доски
             * @param {number} w Ширина доски
             */
            calcFontSize (t, w) {
                let font = 0;

                if (t == w) {
                    if (t < 50) { font = t * w * 0.003 }
                    else if (t < 100) { font = t * w * 0.0015 }
                    else if (t < 150) { font = t * w * 0.0009 }
                    else if (t < 200) { font = t * w * 0.0006 }
                    else if (t < 250) { font = t * w * 0.0005 }
                    else if (t < 300) { font = t * w * 0.0004 }
                    else if (t < 400) { font = t * w * 0.0003 }
                    else { font = t * w * 0.0002 }
                } else {
                    if (t < 20) { font = t * w * 0.003 }
                    else if (t < 70) { font = t * w * 0.002 }
                    else if (t < 120) { font = t * w * 0.001 }
                    else { font = t * w * 0.0005 }
                }

                return font;
            },

            /**
             * Очистка объектов
             */
            cleanup () {
                while(this.models.length > 0) {
                    this.models[this.models.length - 1].geometry.dispose();
                    this.models[this.models.length - 1].material.dispose();
                    //this.models[this.models.length - 1].texture.dispose();
                    this.scene.remove(this.models[this.models.length - 1]);
                    this.models.pop();
                }

                this.cleanupLog();

                this.models   = undefined;
                this.models   = [];
                this.scene    = undefined;
                this.camera   = undefined;
                this.renderer = undefined;
            },

            /**
             * Очистка объектов отображаемых сечений
             */
            cleanupBoards () {
                while(this.models.length > 0) {
                    this.models[this.models.length - 1].geometry.dispose();
                    this.models[this.models.length - 1].material.dispose();
                    this.scene.remove(this.models[this.models.length - 1]);
                    this.models.pop();
                }
            },

            /**
             * Очистка объекта модели бревна
             */
            cleanupLog () {
                if (this.logModel) {
                    this.logModel.geometry.dispose();
                    this.logModel.material.dispose();
                    this.scene.remove(this.logModel);
                    this.logModel = undefined;
                }
            },

            /**
             * Отрисовка модели бревна
             *
             * @param {object} model  Модель
             * @param {number} zScale Сжатие по оси Z
             */
            drawModel (model, zScale) {
                if (this.scene) { this.cleanupLog(); }

                let slices = [];
                //let dotsPerSlice = model.head.DotsPerSlice;

                let dotsPerSlice = 0;

                if (model.Slices !== undefined) {
                    model.Slices.forEach(slice => {
                        if (slice.Dots > dotsPerSlice) {
                            dotsPerSlice = slice.Dots;
                        }
                    });

                    let ZZoom = zScale ? 2 : 1;

                    model.Slices.forEach(slice => {
                        //let i = 0;
                        let curSlice = [];

                        for (let i = 0; i < slice.Dots * 2; i = i + 2) {
                            curSlice.push([slice.XY[i], slice.XY[i + 1], slice.Z / ZZoom]);
                        }

                        let lastDotIndex = (slice.Dots - 1) * 2

                        // Если в сечении недостаточно точек, добавим до нужного количества
                        if (slice.Dots < dotsPerSlice) {
                            for (let i = 0; i < dotsPerSlice - slice.Dots; i++) {
                                curSlice.push([slice.XY[lastDotIndex], slice.XY[lastDotIndex + 1], slice.Z / ZZoom]);
                            }
                        }

                        slices.push(curSlice);
                    });
                }

                let max_z = 0;

                slices.forEach(dots => {
                    dots.forEach(coord =>{
                        if (coord[2] > max_z ) {
                            max_z = coord[2];
                        }
                    });
                });

                let z_center = Math.floor(max_z / 2);

                /*
                if (document.querySelector("#c") == null) {
                    return;
                }

                const canvas = document.querySelector("#c");
                */
                let width  = window.innerWidth;
                let height = window.innerHeight;
                const canvas = document.querySelector("#c");

                canvas.setAttribute("width", width);
                canvas.setAttribute("height", height);

                this.renderer = new WebGLRenderer({canvas});
                this.renderer.setClearColor(0xaaaaaa);
                /*
                const renderer = new THREE.WebGLRenderer({
                    canvas,
                    alpha: true
                });
                */

                const fov    = 45;
                const aspect = 2;   // the canvas default
                const near   = 0.1;
                const far    = max_z; //50000; //100; //

                this.camera  = new PerspectiveCamera(fov, aspect, near, far);
                this.camera.position.x = 4000;

                const controls = new OrbitControls(this.camera, canvas);

                controls.target.set(0, 5, 0);
                controls.update();

                this.scene = undefined;
                this.scene = new Scene();
                //scene.background = new THREE.Color("white");

                {   // Свет
                    const skyColor    = 0xffffff;
                    const groundColor = 0x555555;
                    const intensity   = 1;
                    const light = new HemisphereLight(skyColor, groundColor, intensity);
                    this.scene.add(light);
                }

                const vertices = [];
                const normals  = [];
                const scale    = 10;
                slices.forEach(dots => {
                    dots.forEach(coord => {
                        vertices.push(Math.floor(coord[0] / scale));
                        vertices.push(Math.floor(coord[1] / scale));
                        vertices.push(Math.floor((coord[2] - z_center) / scale));
                        normals.push( 0, 0, 1 );
                    });
                });

                const geometry = new BufferGeometry();

                geometry.setAttribute( 'position', new Float32BufferAttribute( vertices, 3 ) );
                geometry.setAttribute( 'normal', new Float32BufferAttribute( normals, 3 ) );

                const indices = [];
                for (let i = 0; i < slices.length - 1; i++) {
                    let j = 0;
                    for (j = 0; j < dotsPerSlice - 1; j++) {
                        indices.push(
                            i * dotsPerSlice + j,
                            i * dotsPerSlice + dotsPerSlice + j + 1,
                            i * dotsPerSlice + dotsPerSlice + j
                        );
                        indices.push(
                            i * dotsPerSlice + j,
                            i * dotsPerSlice + j + 1,
                            i * dotsPerSlice + dotsPerSlice + j + 1
                        );
                        indices.push(
                            i * dotsPerSlice + j,
                            i * dotsPerSlice + dotsPerSlice + j,
                            i * dotsPerSlice + dotsPerSlice + j + 1
                        );
                        indices.push(
                            i * dotsPerSlice + j,
                            i * dotsPerSlice + dotsPerSlice + j + 1,
                            i * dotsPerSlice + j + 1
                        );
                    }

                    indices.push(
                            i * dotsPerSlice + j,
                            i * dotsPerSlice + j + 1,
                            i * dotsPerSlice + j + dotsPerSlice
                        );
                    indices.push(
                        i * dotsPerSlice + j,
                        i * dotsPerSlice,
                        i * dotsPerSlice + j + 1
                    );
                    indices.push(
                        i * dotsPerSlice + j,
                        i * dotsPerSlice + j + dotsPerSlice,
                        i * dotsPerSlice + j + 1
                    );
                    indices.push(
                        i * dotsPerSlice + j,
                        i * dotsPerSlice + j + 1,
                        i * dotsPerSlice
                    );
                }

                geometry.setIndex( indices );

                //const modelsList = [
                    this.makeInstance(geometry, 0x95651f, 0)
                //];

                //modelsList[0].rotation.y = -Math.PI / 2;
                //console.log(this.camera);
                //this.camera.rotation.x = -Math.PI / 4;


                requestAnimationFrame(this.render);

                { // Поддержка скриншотов
                    const elem = document.querySelector("#screenshot");
                    if (!elem.onclick) {
                        elem.onclick = () => {
                            this.render();
                            canvas.toBlob((blob) => {
                                saveBlob(blob, `screencapture-${canvas.width}x${canvas.height}.png`);
                            });
                        }
                    }
                    /*
                    elem.addEventListener("click", () => {
                        render();
                        canvas.toBlob((blob) => {
                            saveBlob(blob, `screencapture-${canvas.width}x${canvas.height}.png`);
                        });
                    });
                    */

                    let component = this;

                    const saveBlob = (function () {
                        const a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style.display = "none";

                        return function saveData(blob, fileName) {
                            //const url = window.URL.createObjectURL(blob);
                            const url = component.watermarkedDataURL(canvas, "Saws optimization Web by AVTOMATIKA-VEKTOR");

                            a.href     = url;
                            a.download = fileName;
                            a.click();
                            component.alert = component.$t("imageExportCompleted");
                        };
                    }());
                }
            },

            /**
             * Отрисовка боковых досок
             *
             * @param {object} scene   Сцена
             * @param {object} pattern Параметры постава
             * @param {number} order   Порядок досок: 1 - левые/правые, 2 - верхние/нижние
             * @param {object} log     Параметры бревна
             * @param {number} sq      Общая толщина центральных досок
             */
            drawSideBoard (scene, pattern, order, cenOrder, log, sq) {
                let geometryBoard;
                let size, sizeT;
                const materialBoard  = new MeshLambertMaterial({ color: 0xebc81a });
                let col = pattern.items.length;
                let usedArea1 = 0;
                let usedArea2 = 0;
                let sqW = 0;
                let kerf = (pattern.kerf) ? pattern.kerf : 5;
                let divider = (this.zScale) ? 2 : 1;

                //Отрисовка первой половины
                for (let i = cenOrder-1; i >= 0; --i) {
                    if (pattern.items[i].hasOwnProperty("items")) {
                        sqW = (pattern.items[i].items[0].ws * pattern.items[i].items.length) + ((pattern.items[i].items.length - 1) * kerf);
                        sqW /= 2;
                        let containers = pattern.items[i].items.length;

                        for (let j = 0; j < pattern.items[i].items.length; j++) {
                            geometryBoard = new BoxGeometry (pattern.items[i].items[j].ts, pattern.items[i].items[j].ws, log.L*10/divider);

                            //let board = new THREE.Mesh(geometryBoard, materialBoard);
                            this.models.push(new Mesh(geometryBoard, materialBoard));
                            let board = this.models[this.models.length - 1];

                            scene.add(board);

                            if (order == 1) { // Левые/правые
                                board.position.x = sq + usedArea1 + pattern.items[i].items[j].ts/2 + kerf;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    board.position.y = 0;
                                } else {
                                    board.position.y = sqW - pattern.items[i].items[j].ws/2;
                                }
                            } else {          // Верхние/нижние
                                board.position.y = sq + usedArea1 + pattern.items[i].items[j].ts/2 + kerf;
                                board.rotation.z = Math.PI /2;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    board.position.x = 0;
                                } else {
                                    board.position.x = sqW - pattern.items[i].items[j].ws/2;
                                }
                            }

                            this.addEdges(board);

                            this.models.push (new Text());
                            size = this.models[this.models.length - 1];
                            scene.add(size);

                            size.maxWidth = pattern.items[i].items[j].wn;
                            size.text = String(pattern.items[i].items[j].tn) + " x " + String(pattern.items[i].items[j].wn) + " x " + String((log.L/100).toFixed(1));
                            size.fontSize = this.calcFontSize(pattern.items[i].items[j].ts, pattern.items[i].items[j].ws);
                            size.color    = 0x000000;
                            size.anchorX  = "50%";
                            size.anchorY  = "50%";
                            size.position.z = log.L*10/(2*divider) + 2;

                            if (order == 1) { // Левые/правые
                                size.position.x = sq + usedArea1 + pattern.items[i].items[j].ts/2 + kerf;
                                size.rotation.z = Math.PI /2;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    size.position.y = 0;
                                } else {
                                    size.position.y = sqW - pattern.items[i].items[j].ws/2;
                                }
                            } else {          // Верхние/нижние
                                size.position.y = sq + usedArea1 + pattern.items[i].items[j].ts/2 + kerf;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    size.position.x = 0;
                                } else {
                                    size.position.x = sqW - pattern.items[i].items[j].ws/2;
                                }
                            }

                            this.models.push (new Text());
                            sizeT = this.models[this.models.length - 1];
                            sizeT.copy(size);
                            if (order == 1) { // Левые/правые
                            sizeT.rotation.z = Math.PI/2;
                            }
                            sizeT.position.z = -(log.L*10/(2*divider) + 1);
                            sizeT.rotation.y = Math.PI;
                            scene.add(sizeT);

                            sqW = sqW - pattern.items[i].items[j].ws - kerf;
                        }

                        usedArea1 += pattern.items[i].items[0].ts + kerf;
                    } else {
                        geometryBoard = new BoxGeometry (pattern.items[i].ts, pattern.items[i].ws, log.L*10/divider);

                        //let board = new THREE.Mesh(geometryBoard, materialBoard);
                        this.models.push(new Mesh(geometryBoard, materialBoard));
                        let board = this.models[this.models.length - 1];

                        scene.add(board);

                        if (order == 1) { // Левые/правые
                            board.position.x = sq + usedArea1 + pattern.items[i].ts/2 + kerf;
                        } else {          // Верхние/нижние
                            board.position.y = sq + usedArea1 + pattern.items[i].ts/2 + kerf;
                            board.rotation.z = Math.PI /2;
                        }

                        this.addEdges(board);

                        this.models.push (new Text());
                        size = this.models[this.models.length - 1];
                        scene.add(size);

                        size.maxWidth = pattern.items[i].wn;
                        size.text = String(pattern.items[i].tn) + " x " + String(pattern.items[i].wn) + " x " + String((log.L/100).toFixed(1));
                        size.fontSize = this.calcFontSize(pattern.items[i].ts, pattern.items[i].ws);
                        size.anchorX  = "50%";
                        size.anchorY  = "50%";
                        size.color    = 0x000000;
                        size.position.z = log.L*10/(2*divider) + 2;

                        if (order == 1) { // Левые/правые
                            size.position.x = sq + usedArea1 + pattern.items[i].ts/2 + kerf;
                            size.rotation.z = Math.PI /2;
                        } else {          // Верхние/нижние
                            size.position.y = sq + usedArea1 + pattern.items[i].ts/2 + kerf;
                        }

                        this.models.push (new Text());
                        sizeT = this.models[this.models.length - 1];
                        sizeT.copy(size);
                        if (order == 1) { // Левые/правые
                            sizeT.rotation.z = Math.PI/2;
                        }
                        sizeT.position.z = -(log.L*10/(2*divider) + 1);
                        sizeT.rotation.y = Math.PI;
                        scene.add(sizeT);

                        usedArea1 += pattern.items[i].ts + kerf;
                    }
                }
                //Отрисовка второй половины
                for (let i = cenOrder + 1; i < col; ++i) {
                    if (pattern.items[i].hasOwnProperty("items")) {
                        sqW = (pattern.items[i].items[0].ws * pattern.items[i].items.length) + ((pattern.items[i].items.length - 1) * kerf);
                        sqW /= 2;
                        let containers = pattern.items[i].items.length;
                        for (let j = 0; j < pattern.items[i].items.length; j++) {
                            geometryBoard = new BoxGeometry (pattern.items[i].items[j].ts, pattern.items[i].items[j].ws, log.L*10/divider);

                            //let board = new THREE.Mesh(geometryBoard, materialBoard);
                            this.models.push(new Mesh(geometryBoard, materialBoard));
                            let board = this.models[this.models.length - 1];

                            scene.add(board);

                            if (order == 1) { // Левые/правые
                                board.position.x = -(sq + usedArea2 + pattern.items[i].items[j].ts/2 + kerf);
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    board.position.y = 0;
                                } else {
                                    board.position.y = sqW - pattern.items[i].items[j].ws/2;
                                }
                            } else {          // Верхние/нижние
                                board.position.y = -(sq + usedArea2 + pattern.items[i].items[j].ts/2 + kerf);
                                board.rotation.z = Math.PI /2;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    board.position.x = 0;
                                } else {
                                    board.position.x = sqW - pattern.items[i].items[j].ws/2;
                                }
                            }

                            this.addEdges(board);

                            this.models.push (new Text());
                            size = this.models[this.models.length - 1];
                            scene.add(size);

                            size.maxWidth = pattern.items[i].items[j].wn;
                            size.text = String(pattern.items[i].items[j].tn) + " x " + String(pattern.items[i].items[j].wn) + " x " + String((log.L/100).toFixed(1));
                            size.fontSize = this.calcFontSize(pattern.items[i].items[j].ts, pattern.items[i].items[j].ws);
                            size.anchorX  = "50%";
                            size.anchorY  = "50%";
                            size.color    = 0x000000;
                            size.position.z = log.L*10/(2*divider) + 2;

                            if (order == 1) { // Левые/правые
                                size.position.x = -(sq + usedArea2 + pattern.items[i].items[j].ts/2 + kerf);
                                size.rotation.z = Math.PI /2;
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    size.position.y = 0;
                                } else {
                                    size.position.y = sqW - pattern.items[i].items[j].ws/2;
                                }
                            } else { // Верхние/нижние
                                size.position.y = -(sq + usedArea2 + pattern.items[i].items[j].ts/2 + kerf);
                                if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                    size.position.x = 0;
                                } else {
                                    size.position.x = sqW - pattern.items[i].items[j].ws/2;
                                }
                            }

                            this.models.push (new Text());
                            sizeT = this.models[this.models.length - 1];
                            sizeT.copy(size);
                            sizeT.rotation.y = Math.PI;
                            if (order == 1) { // Левые/правые
                            sizeT.rotation.z = Math.PI/2;
                            }
                            sizeT.position.z = -(log.L*10/(2*divider) + 1);
                            scene.add(sizeT);

                            sqW = sqW - pattern.items[i].items[j].ws - kerf;
                        }

                        usedArea2 += pattern.items[i].items[0].ts + kerf;
                    } else {
                        geometryBoard = new BoxGeometry (pattern.items[i].ts, pattern.items[i].ws, log.L*10/divider);

                        //let board = new THREE.Mesh(geometryBoard, materialBoard);
                        this.models.push(new Mesh(geometryBoard, materialBoard));
                        let board = this.models[this.models.length - 1];

                        scene.add(board);

                        if (order == 1) { // Левые/правые
                            board.position.x = -(sq + usedArea2 + pattern.items[i].ts/2 + kerf);
                        } else {          // Верхние/нижние
                            board.position.y = -(sq + usedArea2 + pattern.items[i].ts/2 + kerf);
                            board.rotation.z = Math.PI /2;
                        }

                        this.addEdges(board);

                        this.models.push (new Text());
                        size = this.models[this.models.length - 1];
                        scene.add(size);

                        size.maxWidth = pattern.items[i].wn;
                        size.text = String(pattern.items[i].tn) + " x " + String(pattern.items[i].wn) + " x " + String((log.L/100).toFixed(1));
                        size.fontSize = this.calcFontSize(pattern.items[i].ts, pattern.items[i].ws);
                        size.anchorX  = "50%";
                        size.anchorY  = "50%";
                        size.color    = 0x000000;
                        size.position.z = log.L*10/(2*divider) + 2;
                        if (order == 1) { // Левые/правые
                            size.position.x = -(sq + usedArea2 + pattern.items[i].ts/2 + kerf);
                            size.rotation.z = Math.PI /2;
                        } else {          // Верхние/нижние
                            size.position.y = -(sq + usedArea2 + pattern.items[i].ts/2 + kerf);
                        }

                        sizeT = new Text();this.models.push (new Text());
                        sizeT = this.models[this.models.length - 1];
                        sizeT.copy(size);
                        if (order == 1) { // Левые/правые
                            sizeT.rotation.z = Math.PI/2;
                        }
                        sizeT.position.z = -(log.L*10/(2*divider) + 1);
                        sizeT.rotation.y = Math.PI;
                        scene.add(sizeT);

                        usedArea2 += pattern.items[i].ts + kerf;
                    }
                }
            },

            /**
             * Отрисовка центральных досок
             *
             * @param {object} scene   Сцена
             * @param {object} pattern Параметры постава
             * @param {object} log     Параметры бревна
             */
            drawCenter(scene, pattern, log) {
                let geometryBoard;
                let size, sizeT;
                const materialBoard  = new MeshLambertMaterial({ color: 0xebaf1a });
                let col = pattern.items.length;
                let sqT = 0,
                    sqW = 0;
                let kerf = (pattern.kerf) ? pattern.kerf : 5;
                let divider = (this.zScale) ? 2 : 1;

                for (let i=0; i < col; i++){
                    if (pattern.items[i].hasOwnProperty("items")) {
                        sqT += pattern.items[i].items[0].ts;
                        sqW = (pattern.items[i].items[0].ws * pattern.items[i].items.length) + ((pattern.items[i].items.length - 1) * kerf);
                        if (i != col-1) {
                            sqT += kerf;
                        }
                    } else {
                        sqT += pattern.items[i].ts;
                        sqW = pattern.items[0].ws;
                        if (i != col-1) {
                            sqT += kerf;
                        }
                    }
                }

                sqT /= 2;
                sqW /= 2;

                let centerAreaT = sqT;
                let centerAreaW = sqW;

                for (let i = 0; i < col; i++) {
                    if (pattern.items[i].hasOwnProperty("items")) {
                        sqW = centerAreaW;
                        let containers = pattern.items[i].items.length;
                        for (let j = 0; j < pattern.items[i].items.length; j++) {
                            geometryBoard = new BoxGeometry (pattern.items[i].items[j].ts, pattern.items[i].items[j].ws, log.L*10/divider);

                            //let board = new THREE.Mesh(geometryBoard, materialBoard);
                            this.models.push(new Mesh(geometryBoard, materialBoard));
                            let board = this.models[this.models.length - 1];

                            scene.add(board);

                            board.position.y = sqT - pattern.items[i].items[j].ts/2;

                            if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                board.position.x = 0;
                            } else {
                                board.position.x = sqW - pattern.items[i].items[j].ws/2;
                            }

                            board.rotation.z = Math.PI /2;

                            this.addEdges(board);

                            this.models.push (new Text());
                            size = this.models[this.models.length - 1];
                            scene.add(size);

                            size.maxWidth = pattern.items[i].items[j].wn;
                            size.text = String(pattern.items[i].items[j].tn) + " x " + String(pattern.items[i].items[j].wn) + " x " + String((log.L/100).toFixed(1));
                            size.fontSize = this.calcFontSize(pattern.items[i].items[j].tn, pattern.items[i].items[j].wn);
                            size.anchorX  = "50%";
                            size.anchorY  = "50%";
                            size.position.y = sqT - pattern.items[i].items[j].ts/2;

                            if (j+1 == Math.round(containers/2) && containers%2 != 0) {
                                size.position.x = 0;
                            } else {
                                size.position.x = sqW - pattern.items[i].items[j].ws/2;
                            }
                            size.position.z = log.L*10/(2*divider) + 1;
                            size.color = 0x000000;

                            this.models.push (new Text());
                            sizeT = this.models[this.models.length - 1];
                            sizeT.copy(size);
                            sizeT.rotation.y = Math.PI;
                            sizeT.position.z = -(log.L*10/(2*divider) + 1);
                            scene.add(sizeT);

                            sqW = sqW - pattern.items[i].items[j].ws - kerf;
                        }

                        sqT = sqT - pattern.items[i].items[0].ts - kerf;
                    } else {
                        geometryBoard = new BoxGeometry (pattern.items[i].ts, pattern.items[i].ws, log.L*10/divider);
                        //let board = new THREE.Mesh(geometryBoard, materialBoard);
                        this.models.push(new Mesh(geometryBoard, materialBoard));
                        let board = this.models[this.models.length - 1];

                        scene.add(board);

                        board.position.y = sqT - pattern.items[i].ts/2;
                        board.rotation.z = Math.PI /2;

                        this.addEdges(board);

                        this.models.push (new Text());
                        size = this.models[this.models.length - 1];
                        scene.add(size);

                        size.maxWidth = pattern.items[i].wn;
                        size.text = String(pattern.items[i].tn) + " x " + String(pattern.items[i].wn) + " x " + String((log.L/100).toFixed(1));
                        size.fontSize = this.calcFontSize(pattern.items[i].tn, pattern.items[i].wn);
                        size.anchorX = "50%";
                        size.anchorY = "50%";
                        size.position.y = sqT - pattern.items[i].ts/2;
                        size.position.z = log.L*10/(2*divider) + 1;
                        size.color = 0x000000;

                        this.models.push (new Text());
                        sizeT = this.models[this.models.length - 1];
                        sizeT.copy(size);
                        sizeT.rotation.y = Math.PI;
                        sizeT.position.z = -(log.L*10/(2*divider) + 5);
                        scene.add(sizeT);

                        sqT = sqT - pattern.items[i].ts - kerf;
                    }
                }

                return [centerAreaT, centerAreaW * 2];
            },

            /**
             * Отрисовка постава
             */
            drawPattern () {
                let centArea;
                let cenOrder1 = 0;
                let cenOrder2 = 0;

                if (this.pattern.order == 1) {
                    cenOrder1 = this.findContainerCenter(this.pattern);
                    if (this.pattern.items[cenOrder1].order == 2) {
                        cenOrder2 = this.findContainerCenter(this.pattern.items[cenOrder1]);
                        centArea  = this.drawCenter(this.scene, this.pattern.items[cenOrder1].items[cenOrder2], this.model.head);
                        this.drawSideBoard(this.scene, this.pattern.items[cenOrder1], 2, cenOrder2, this.model.head, centArea[0]);
                        this.drawSideBoard(this.scene, this.pattern, 1, cenOrder1, this.model.head, centArea[1]/2);
                    } else {
                        centArea = this.drawCenter(this.scene, this.pattern.items[cenOrder1], this.model.head);
                        this.drawSideBoard(this.scene, this.pattern, 1, cenOrder1, this.model.head, centArea[1]/2);
                    }
                }
                if (this.pattern.order == 2) {
                    cenOrder2 = this.findContainerCenter(this.pattern);
                    centArea  = this.drawCenter(this.scene, this.pattern.items[cenOrder2], this.model.head);
                    this.drawSideBoard(this.scene, this.pattern, 2, cenOrder2, this.model.head, centArea[0]);
                }
                if (this.pattern.order == 0) {
                    centArea = this.drawCenter(this.scene, this.pattern, this.model.head);
                }

                //this.$debug.log(this.models);
            },

            findContainerCenter (object) {
                //const obj = JSON.parse(JSON.stringify(object));
                const obj = object;
                let n = 0;

                if (obj.order == 1) {
                    for (let item1 of obj.items) {
                        if (item1.order == 2) {
                            return n;
                        }
                        n++;
                    }
                }

                if (obj.order == 2) {
                    for (let item2 of obj.items) {
                        if (item2.order == 0) {
                            return n;
                        }
                        n++;
                    }
                }

                return n;
            },

            /**
             * Изменение положения 3Д-модели бревна
             *
             * @param {object} evt Вызвавшее обработчик событие
             */
            logCorrection (evt) {
                const cameraPosition = this.camera.position.z;
                evt.preventDefault();

                if (evt.type == "mouseup" || evt.type == "touchend") {
                    clearInterval(this.timerId);
                } else {
                    this.timerId = setInterval(() => {
                        //evt.preventDefault();

                        switch (evt.target.id) {
                            case "i-up":
                                this.logModel.position.y++;
                                break;
                            case "i-down":
                                this.logModel.position.y--;
                                break;
                            case "i-right":
                                this.logModel.position.x += cameraPosition > 0 ? 1 : -1;
                                break;
                            case "i-left":
                                this.logModel.position.x += cameraPosition > 0 ? -1 : 1;
                                break;
                            case "i-log-rotate-clockwise":
                                this.logModel.rotation.z += cameraPosition > 0 ? -0.0175 : 0.0175;
                                break;
                            case "i-log-rotate-counterclockwise":
                                this.logModel.rotation.z += cameraPosition > 0 ? 0.0175 : -0.0175;
                                break;
                            case "i-horizontal-rotate-clockwise":
                                this.logModel.rotation.x += cameraPosition > 0 ? -0.00875 : 0.00875;
                                break;
                            case "i-horizontal-rotate-counterclockwise":
                                this.logModel.rotation.x += cameraPosition > 0 ? 0.00875 : -0.00875;
                                break;
                            case "i-axis-z-rotate-clockwise":
                                this.logModel.rotation.y -= 0.00875;
                                break;
                            case "i-axis-z-rotate-counterclockwise":
                                this.logModel.rotation.y += 0.00875;
                                break;
                        }
                    }, 25);
                }
            },

            /**
             * Создание 3D-объекта
             *
             * @param {object} geometry 3D-объект
             * @param {string} color    Цвет
             * @param {number} x        Координата по оси X
             */
            makeInstance (geometry, color, x) {
                // полупрозрачность https://stackoverflow.com/questions/17396111/intermittent-semi-transparent-sphere-in-three-js
                // const material = new THREE.MeshStandardMaterial({ color, transparent: true, opacity: 0.5 });
                //const material = new THREE.MeshBasicMaterial({ color, transparent: true, opacity: 0.65 });
                //const model3D  = new THREE.Mesh(geometry, material);
                const material = new MeshStandardMaterial({ color, transparent: true, opacity: 0.55, flatShading: true });

                material.side = DoubleSide;

                this.logModel = new Mesh(geometry, material);

                //this.scene.add(model3D);
                this.scene.add(this.logModel);

                //model3D.position.x = x;
                this.logModel.position.x = x;

                //return model3D;
                return this.logModel;
            },

            /**
             * Отрисовка
             */
            render () {
                if (this.resizeRendererToDisplaySize(this.renderer)) {
                    const canvas = this.renderer.domElement;

                    this.camera.aspect = canvas.clientWidth / canvas.clientHeight;

                    this.camera.updateProjectionMatrix();
                }
/*
                modelsList.forEach((cube, ndx) => {
                    const speed = 1 + ndx * .1;
                    const rot = time * speed;
                    cube.rotation.x = rot;
                    cube.rotation.y = rot;
                });
*/
                if (this.scene !== undefined && this.camera !== undefined) {
                    this.renderer.render(this.scene, this.camera);

                    requestAnimationFrame(this.render);
                }
            },

            /**
             * Адаптация визуализатора под размер экрана
             *
             * @param {object} renderer Визуализатор
             *
             * @returns {bool} Флаг изменения размера
             */
            resizeRendererToDisplaySize (renderer) {
                try {
                    if (renderer == undefined) {
                        return false;
                    }

                    const canvas = renderer.domElement;
                    const width  = canvas.clientWidth;
                    const height = canvas.clientHeight;
                    const needResize = canvas.width !== width || canvas.height !== height;

                    if (needResize) {
                        renderer.setSize(width, height, false);
                    }

                    return needResize;
                } catch (err) {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `ThreeDVue.vue -> resizeRendererToDisplaySize: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    return false;
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
            * Отрисовка водяного знака
            *
            * @param {object} canvas        Холст
            * @param {string} watermarkText Текст водяного знака
            */
            watermarkedDataURL (canvas, text) {
                let tempCanvas = document.createElement("canvas");
                let tempCtx    = tempCanvas.getContext("2d");
                let cw, ch;

                this.render();

                cw = tempCanvas.width  = canvas.width;
                ch = tempCanvas.height = canvas.height;
                tempCtx.drawImage(canvas, 0, 0);
                tempCtx.font = "24px verdana";

                /* Watermark */
                let textWidth = tempCtx.measureText(text).width;

                tempCtx.globalAlpha = .5;
                tempCtx.fillStyle   = "white";
                tempCtx.fillText(text, cw - textWidth - 10, ch - 20);
                tempCtx.fillStyle   = "black";
                tempCtx.fillText(text, cw - textWidth - 8, ch - 18);

                /* Информация о бревне */
                tempCtx.font        = "12px arial";
                tempCtx.globalAlpha = 1;
                tempCtx.fillStyle   = "black";

                let i = 1;
                tempCtx.fillText(`${this.$t("taper")}: ${this.model.head.Sbeg} ${this.$t("cm")}/${this.$t("m")}`, 10, ch - 20 * i);
                i++;
                tempCtx.fillText(`${this.$t("curvature")}: ${this.model.head.Curvature * .1}%`, 10, ch - 20 * i);
                i++;
                tempCtx.fillText(`${this.$t("length")}: ${this.model.head.L} ${this.$t("cm")}`, 10, ch - 20 * i);
                i++;
                tempCtx.fillText(
                    this.$t("dButt") + ": " +
                    (
                        this.model.head.BackEndD > this.model.head.FrontEndD
                            ? this.model.head.BackEndD
                            : this.model.head.FrontEndD
                    ) +
                    this.$t("mm"),
                    10, ch - 20 * i
                );
                i++;
                tempCtx.fillText(`${this.$t("dTop")}: ${this.model.head.TopD} ${this.$t("mm")}`, 10, ch - 20 * i);
                i++;
                tempCtx.fillText(`${this.$t("time")}: ${this.model.head.TimeStamp}`, 10, ch - 20 * i);

                return(tempCanvas.toDataURL());
            }
        }
    }
</script>

<style lang="sass" scoped>
    #c
        height: 100%
        width: 100%
        background-color: #000

    button
        &#screenshot, &#up, &#right, &#down, &#left,
        &#horizontal-rotate-counterclockwise, &#horizontal-rotate-clockwise,
        &#axis-z-rotate-counterclockwise, &#axis-z-rotate-clockwise,
        &#log-rotate-clockwise, &#log-rotate-counterclockwise
            position: absolute
            padding: 10px
            margin: 2px
            border: none
            border-radius: 30px
            cursor: pointer
            >
                i
                    color: #000
            &:hover
                background: #fff

            &:focus
                outline: none

        &#screenshot
            left: 10px
            top: 10px
        &#up
            //bottom: 75px
            //right: 45px
            bottom: 145px
            right: 80px
        &#right
            //bottom: 45px
            bottom: 80px
            right: 15px
        &#down
            bottom: 15px
            //right: 45px
            right: 80px
        &#left
            //bottom: 45px
            //right: 75px
            bottom: 80px
            right: 145px
        &#log-rotate-counterclockwise
            bottom: 80px
            right: 105px
        &#log-rotate-clockwise
            bottom: 80px
            right: 55px
        &#horizontal-rotate-counterclockwise
            //bottom: 75px
            //right: 145px
            bottom: 75px
            right: 15px
            bottom: 115px
            right: 45px
        &#horizontal-rotate-clockwise
            //bottom: 15px
            //right: 145px
            //bottom: 75px
            //right: 75px
            bottom: 115px
            right: 115px
        &#axis-z-rotate-counterclockwise
            //bottom: 45px
            //right: 175px
            //bottom: 15px
            //right: 75px
            bottom: 45px
            right: 115px
        &#axis-z-rotate-clockwise
            //bottom: 45px
            //right: 115px
            bottom: 45px
            right: 45px

    #info
        background: none
        color: #000
        font-family: Arial, Helvetica, sans-serif
        font-size: 12px
        margin: 10px
        position: absolute
        bottom: 5px

    .info-table
        margin: 10px
        padding: 10px
        position: absolute
        bottom: 5px
        background: rgba(255, 255, 255, .5)
        border: solid 1px #000
        td
            padding: 2px
            color: #000
</style>
